import Card from "components/card";
import { MdRemoveRedEye } from "react-icons/md";
import { useDisclosure } from "@chakra-ui/hooks";
import CustomModal from "components/modals";
import CustomButton from "components/button";
import { useQuery } from "@tanstack/react-query";
import { reqFunction } from "utils/API";
import SimpleTable from "components/tables/SimpleTable";
import { renderTimeJalali } from "utils/TimeUtiles";
// import UserForm from "components/forms/UserForm";
import { useState } from "react";
import CustomPagination from "components/pagination";
import { CountOption, countSelect } from "variables";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { vscDarkPlus } from "react-syntax-highlighter/dist/esm/styles/prism";
import Loading from "components/loading";
import moment from "moment-jalaali";

export type SystemLogObject = {
  all_system_logs: number;
  system_log_id: string;
  system_log_action: string;
  system_log_object_action_on: string;
  system_log_action_table: string;
  system_log_field_changes: Record<string, any> | null;
  system_log_message: string;
  system_log_create_time: string;
  system_log_admin: null | string;
  // system_log_user: null | string;
  system_log_ip: null | string;
  system_log_status: string;
  system_log_os: null | string;
  system_log_browser: null | string;
};
type systemLogTable = Array<{
  logAction: string;
  logTable: string;
  logCreateTime: string;
  logAdmin: string;
  // logUser: string;
  IP: string;
  Status: string;
  OS: string;
  Browser: string;
  logDetails: JSX.Element;
}>;
const SystemLogs = () => {
  const [page, setPage] = useState<number>(1);
  const [count, setCount] = useState<CountOption>(countSelect[0]);
  const [log, setLog] = useState<{} | string>("");

  const [statusFilter, setStatusFilter] = useState<null | string>(null);
  const [actionFilter, setActionFilter] = useState<null | string>(null);
  const [tableFilter, setTableFilter] = useState<null | string>(null);

  // Controlled input fields (typing)
  const [ipInput, setIpInput] = useState("");
  const [adminPhoneInput, setAdminPhoneInput] = useState("");

  // Actual filters used in the query
  const [ipFilter, setIpFilter] = useState<string | null>(null);
  const [adminPhoneFilter, setAdminPhoneFilter] = useState<string | null>(null);

  const [startTimeInput, setStartTimeInput] = useState<string | null>(null);
  const [endTimeInput, setEndTimeInput] = useState<string | null>(null);

  const [startTime, setStartTime] = useState<string | null>(null);
  const [endTime, setEndTime] = useState<string | null>(null);

  const actionOptions = [
    "",
    "Add",
    "Edit",
    "Delete",
    "Assign",
    "Suspend",
    "Login",
    "Logout",
    "Password",
    "Download",
    "Read",
  ];

  const tableOptions = [
    "",
    "Admins",
    "Users",
    "WaterMeters",
    "WaterMetersModules",
    "WaterMetersProjects",
    "WaterMetersConsumptions",
    "Bills",
    "Pattern",
    "OrderType",
    "Order",
    "Permissions",
    "PermissionCategory",
    "Event",
    "EventType",
    "Snapshots",
    "WaterMetersTags",
    "WaterMetersTypes",
    "ModuleTypes",
    "MqttLoger",
    "SystemLog",
  ];

  const {
    data: systemLogData,
    isLoading: systemLogIsLoading,
    status: systemLogStatus,
  } = useQuery({
    queryKey: [
      "SystemLogsList",
      page,
      count,
      statusFilter,
      actionFilter,
      tableFilter,
      ipFilter,
      adminPhoneFilter,
      startTime,
      endTime,
    ],
    queryFn: () =>
      reqFunction("Log/admin/sysetem/log/getAll", {
        page,
        count: count.value,
        system_log_action: actionFilter,
        system_log_action_table: tableFilter,
        system_log_status: statusFilter,
        system_log_ip: ipFilter,
        system_log_admin_phone: adminPhoneFilter,
        system_log_start_time: startTime,
        system_log_end_time: endTime,
      }),
  });

  console.log(systemLogData);

  const {
    isOpen: isLogOpen,
    onOpen: onLogOpen,
    onClose: onLogClose,
  } = useDisclosure();

  const TableHeader = [
    { title: "عملیات انجام شده", headerKey: "logAction" },
    { title: "جدول عملیات", headerKey: "logTable" },
    { title: "ساعت عملیات", headerKey: "logCreateTime" },
    { title: "ادمین مسئول", headerKey: "logAdmin" },
    // { title: "کاربر مسئول", headerKey: "logUser" },
    { title: "آیپی", headerKey: "IP" },
    { title: "سیستم عامل", headerKey: "OS" },
    { title: "مرورگر", headerKey: "Browser" },
    { title: "وضعیت", headerKey: "Status" },
    { title: "عملیات", headerKey: "logDetails" },
  ];

  const tableData = () => {
    let logTableData: systemLogTable = [];

    if (!systemLogIsLoading && systemLogStatus === "success") {
      systemLogData?.data?.forEach((obj: SystemLogObject) =>
        logTableData.push({
          logAction: obj.system_log_action,
          logTable: obj.system_log_action_table,
          logCreateTime: moment(obj.system_log_create_time, "YYYY-M-D HH:mm:ss")
            .add(3, "hours")
            .add(30, "minutes")
            .format("HH:mm:ss - jYYYY/jM/jD"),
          logAdmin: obj.system_log_admin ? obj.system_log_admin : "__",
          // logUser: obj.system_log_user ? obj.system_log_user : "__",
          IP: obj.system_log_ip ? obj.system_log_ip : "__",
          OS: obj.system_log_os ? obj.system_log_os : "__",
          Browser: obj.system_log_browser ? obj.system_log_browser : "__",

          Status: obj.system_log_status,
          logDetails: renderLogAction(obj),
        })
      );
    }

    return logTableData;
  };

  const renderLogAction = (data: SystemLogObject) => {
    return (
      <div className=" flex items-center justify-center">
        <CustomButton
          onClick={() => renderMessage(data)}
          icon={<MdRemoveRedEye />}
          color="blue"
          extra="!p-2"
        />
      </div>
    );
  };

  const hasKeys = (o: any) =>
    o &&
    typeof o === "object" &&
    !Array.isArray(o) &&
    Object.keys(o).length > 0;

  const renderMessage = (logObject: SystemLogObject) => {
    const payload = hasKeys(logObject.system_log_field_changes)
      ? logObject.system_log_field_changes
      : logObject.system_log_message ?? "—";
    setLog(payload);
    onLogOpen();
  };

  const convertToUTC = (
    jalaliStr: string,
    type: "start" | "end"
  ): string | null => {
    if (!jalaliStr) return null;

    const base = moment(jalaliStr, "jYYYY/jMM/jDD");

    if (type === "start") {
      return base
        .subtract(1, "day")
        .set({ hour: 20, minute: 30, second: 0 })
        .format("YYYY-MM-DDTHH:mm:ss[Z]");
    }

    if (type === "end") {
      return base
        .set({ hour: 20, minute: 29, second: 59 })
        .format("YYYY-MM-DDTHH:mm:ss[Z]");
    }

    return null;
  };

  const handleSearch = () => {
    setIpFilter(ipInput.trim() || null);
    setAdminPhoneFilter(adminPhoneInput.trim() || null);

    setStartTime(convertToUTC(startTimeInput || "", "start"));
    setEndTime(convertToUTC(endTimeInput || "", "end"));
  };

  return (
    <div className=" users-table-container">
      {!systemLogIsLoading && systemLogStatus === "success" ? (
        <>
          {" "}
          <CustomModal
            isOpen={isLogOpen}
            onClose={onLogClose}
            title={"لاگ"}
            modalType="confirmation"
            information={
              <SyntaxHighlighter
                language={typeof log === "string" ? "text" : "json"}
                style={vscDarkPlus}
                customStyle={{ maxWidth: "100%", minHeight: "100px" }}
              >
                {typeof log === "string" ? log : JSON.stringify(log, null, 2)}
              </SyntaxHighlighter>
            }
          />
          <div className="relative flex items-center justify-between p-4">
            <div className="p-4">
              <div className="mb-4 text-xl font-bold text-navy-700 dark:text-white">
                لاگ ها
              </div>

              {/* Filters Section */}
              <div className="flex flex-wrap gap-8">
                {/* Start Time Filter (Jalali) */}
                <div className="flex items-center gap-2">
                  <label className="text-sm font-medium">از تاریخ:</label>
                  <input
                    type="text"
                    placeholder="مثال: 1403/01/01"
                    value={startTimeInput || ""}
                    onChange={(e) => setStartTimeInput(e.target.value)}
                    className="w-32 rounded-md border border-gray-300 bg-white p-2 px-2 py-1 text-sm dark:bg-navy-800 dark:text-white"
                  />
                </div>

                {/* End Time Filter (Jalali) */}
                <div className="flex items-center gap-2">
                  <label className="text-sm font-medium">تا تاریخ:</label>
                  <input
                    type="text"
                    placeholder="مثال: 1403/02/01"
                    value={endTimeInput || ""}
                    onChange={(e) => setEndTimeInput(e.target.value)}
                    className="w-32 rounded-md border border-gray-300 bg-white p-2 px-2 py-1 text-sm dark:bg-navy-800 dark:text-white"
                  />
                </div>

                {/* Action Filter */}
                <div className="flex items-center gap-2 space-x-2">
                  <label className="text-sm font-medium">عملیات:</label>
                  <select
                    value={actionFilter || ""}
                    onChange={(e) => setActionFilter(e.target.value || null)}
                    className="rounded-md border border-gray-300 bg-white p-2 px-2 py-1 text-sm dark:bg-navy-800 dark:text-white"
                  >
                    {actionOptions.map((option) => (
                      <option key={option} value={option}>
                        {option === "" ? "همه" : option}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Table Filter */}
                <div className="flex items-center gap-2 space-x-2">
                  <label className="text-sm font-medium">جدول:</label>
                  <select
                    value={tableFilter || ""}
                    onChange={(e) => setTableFilter(e.target.value || null)}
                    className="rounded-md border border-gray-300 bg-white p-2 px-2 py-1 text-sm dark:bg-navy-800 dark:text-white"
                  >
                    {tableOptions.map((option) => (
                      <option key={option} value={option}>
                        {option === "" ? "همه" : option}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Status Filter */}
                <div className="flex items-center gap-2 space-x-2">
                  <label className="text-sm font-medium">وضعیت:</label>
                  <select
                    value={statusFilter || ""}
                    onChange={(e) => setStatusFilter(e.target.value || null)}
                    className="rounded-md border border-gray-300 bg-white p-2 px-2 py-1 text-sm dark:bg-navy-800 dark:text-white"
                  >
                    <option value="">همه</option>
                    <option value="Success">موفق</option>
                    <option value="Failure">ناموفق</option>
                  </select>
                </div>

                {/* IP Search */}
                <div className="flex items-center gap-2 space-x-2">
                  <label className="text-sm font-medium">آی‌پی:</label>
                  <input
                    type="text"
                    value={ipInput}
                    onChange={(e) => setIpInput(e.target.value)}
                    placeholder="مثال: 192.168.1.1"
                    className="w-40 rounded-md border border-gray-300 bg-white p-2 px-2 py-1 text-sm dark:bg-navy-800 dark:text-white"
                  />
                </div>

                {/* Admin Phone Search */}
                <div className="flex items-center gap-2 space-x-2">
                  <label className="text-sm font-medium">تلفن ادمین:</label>
                  <input
                    type="text"
                    value={adminPhoneInput}
                    onChange={(e) => setAdminPhoneInput(e.target.value)}
                    placeholder="مثال: 09123456789"
                    className="w-40 rounded-md border border-gray-300 bg-white p-2 px-2 py-1 text-sm dark:bg-navy-800 dark:text-white"
                  />
                </div>

                {/* Search Button */}
                <button
                  onClick={handleSearch}
                  className="rounded-md bg-blue-600 px-4 py-1 text-sm text-white transition hover:bg-blue-700"
                >
                  جستجو
                </button>
              </div>
            </div>
          </div>
          <Card extra="!h-[48vh]">
            <div className="table-container mx-auto w-full">
              <SimpleTable
                header={TableHeader}
                data={tableData()}
                hasIndex={true}
                extra="h-[55vh]"
                page={page}
                count={count.value}
              />
            </div>
          </Card>
          <div className="pagination">
            <CustomPagination
              page={page}
              pageSize={count}
              totalData={systemLogData?.data?.[0]?.all_system_logs ?? []}
              changePageFunc={setPage}
              changeCount={setCount}
            />
          </div>
        </>
      ) : (
        // <></>
        <Loading />
      )}
    </div>
  );
};
export default SystemLogs;
